import { useRef, useEffect } from 'react';
import { useContext, useContextSelector } from 'use-context-selector';
import { DEFAULT_STICKY_STATE } from './stickyEmulation';
import { StickyControlContext, StickyValueContext } from './StickyContext';
import { quantizeSize } from './utils';
export function useStickyHeight(ref, direction = 'top') {
    const stickyControlContext = useContext(StickyControlContext);
    if (stickyControlContext == null) {
        throw new Error('StickyContext is not provided');
    }
    const stickyIdRef = useRef(null);
    const stickyId = stickyIdRef.current || stickyControlContext.register();
    stickyIdRef.current = stickyId;
    const itemState = useContextSelector(StickyValueContext, (context) => {
        if (context == null) {
            return null;
        }
        return context.entries[stickyId];
    });
    useEffect(() => {
        stickyControlContext.update(stickyId, ref, {
            shouldInfluenceScroll: false,
            direction,
            offset: 0,
        }, DEFAULT_STICKY_STATE);
    }, [stickyControlContext.update, stickyId, ref, direction]);
    useEffect(() => {
        // Unregister on unmount
        return () => {
            stickyControlContext.unregister(stickyId);
        };
    }, [stickyId]);
    return {
        min: quantizeSize(itemState?.accumulatedOffsetRange?.[0] ?? 0),
        max: quantizeSize(itemState?.accumulatedOffsetRange?.[1] ?? 0),
        current: quantizeSize(itemState?.accumulatedOffset ?? 0),
    };
}
//# sourceMappingURL=useStickyHeight.js.map